const isLoading = (state = false, action) => {
    switch (action.type) {
        case 'user/setLoading':
            return action.payload
        default: return state
    }
}

export default isLoading